import { createPortal } from "react-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import notfound from "assets/img/notfound.png";
import {
  StyledSlideProductDiv,
  StyledSlideProductDiscount,
  StyledSlider,
  StyledTitle,
  StyledImgdiv,
  StyledMain,
  StyledDiv,
  StyledImg,
  Styledh2,
  Styledp,
  StyledGridTop,
  StyledMainTop,
  StyledColorsProduct,
  StyledShowAlldiv,
  StyledImageSlider,
  StyledSliderAcc,
  StyledTypographyContent,
} from "./mainHome.style";
import spliter from "helper/digit-spliter";
import { IMG_BASE_URL } from "constants";
import { Link } from "react-router-dom";
import { Button, Grid } from "@mui/material";
import Container from "@mui/material/Container";
import { FaChevronLeft } from "react-icons/fa";
import logo from "assets/img/mainpic.png";
import baner1 from "assets/img/baner1.png";
import baner2 from "assets/img/baner2.png";
import useHttp from "hooks/use-http";
import SkeletonCM from "components/shared/Skeleton";
import SkeletonProductCM from "components/shared/Skeleton/product";
import parse from "html-react-parser";

const skeleton = [1, 2, 3, 4, 5];

function SampleNextArrowAcc(props) {
  const { className, style, onClick } = props;
  return (
    <div className="Nextarrow" onClick={onClick}>
      <ArrowForwardIosIcon
        className={className}
        style={{ ...style, display: "block" }}
      />
    </div>
  );
}

function SamplePrevArrowAcc(props) {
  const { className, style, onClick } = props;
  return (
    <div className="Prevarrow" onClick={onClick}>
      <ArrowForwardIosIcon
        className={className}
        style={{ ...style, display: "block" }}
      />
    </div>
  );
}

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <ArrowBackIosIcon
      className={className}
      style={{ ...style, display: "block", color: "#009ac2" }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <ArrowForwardIosIcon
      className={className}
      style={{ ...style, display: "block", color: "#009ac2" }}
      onClick={onClick}
    />
  );
}

function MainHomeCM(props) {
  // const { request, loading } = useHttp();
  let settings = {
    // dots: true,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: false,
    // rtl: true,
    nextArrow: <SamplePrevArrow />,
    prevArrow: <SampleNextArrow />,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          // nextArrow: false,
          // prevArrow: false,
        },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1,
          // nextArrow: false,
          // prevArrow: false,
        },
      },
    ],
  };

  let settingsSkeleton = {
    // dots: true,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: false,
    // rtl: true,
    nextArrow: false,
    prevArrow: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          // nextArrow: false,
          // prevArrow: false,
        },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1,
          // nextArrow: false,
          // prevArrow: false,
        },
      },
    ],
  };

  let settingsAmazing = {
    // dots: true,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: false,
    // rtl: true,
    nextArrow: <SamplePrevArrow />,
    prevArrow: <SampleNextArrow />,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          // nextArrow: false,
          // prevArrow: false,
        },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1,
          // nextArrow: false,
          // prevArrow: false,
        },
      },
    ],
  };

  let settingsGallary = {
    // dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    // rtl: true,
    nextArrow: <SamplePrevArrowAcc />,
    prevArrow: <SampleNextArrowAcc />,
  };

  return createPortal(
    <>
      <div>
        <div style={{ marginTop: "46px" }}>
          {/* {props.amazingFurnitureProducts.length > 4 ? ( */}
          <StyledMainTop>
            {props.Loading == true ? (
              <div style={{ textAlign: "center" }}>
                <SkeletonCM Width={300} BackWrapper />
              </div>
            ) : (
              <StyledTitle>پیشنهاد شگفت انگیز مبلمان</StyledTitle>
            )}

            {props.Loading == true ? (
              <div>
                <StyledSlider {...settingsSkeleton}>
                  {skeleton.map((product, index) => (
                    <SkeletonProductCM key={index} />
                  ))}
                </StyledSlider>
              </div>
            ) : (
              <StyledSlider {...settingsAmazing}>
                {props.amazingFurnitureProducts.map((product, index) => (
                  <Link to={`/product/${product.id}`} key={"product" + index}>
                    <StyledSlideProductDiv>
                      <StyledImgdiv>
                        {product.image == null ? (
                          <img src={notfound} alt={product.title} />
                        ) : (
                          <img
                            src={IMG_BASE_URL + product.image}
                            alt={product.title}
                          />
                        )}
                      </StyledImgdiv>
                      <StyledColorsProduct>
                        {product.colors?.map((color, index) => (
                          <span
                            key={"color" + index}
                            style={{ background: color.color_code }}
                          ></span>
                        ))}
                      </StyledColorsProduct>
                      <h2>{product.title}</h2>
                      {product.discount_percent !== 0 ? (
                        <p className="product-p">
                          <span>
                            {" "}
                            {spliter(product?.before_discount_price)}{" "}
                          </span>
                          <span> تومان </span>
                        </p>
                      ) : (
                        <p style={{ height: "26px" }}></p>
                      )}
                      <p>
                        <span style={{ color: "#424242" }}>
                          {" "}
                          {spliter(product.price)}{" "}
                        </span>
                        <span style={{ color: "c3c3c3" }}> تومان </span>
                      </p>
                      {product.discount_percent !== 0 ? (
                        <StyledSlideProductDiscount>
                          {" "}
                          {product.discount_percent} %{" "}
                        </StyledSlideProductDiscount>
                      ) : (
                        " "
                      )}
                    </StyledSlideProductDiv>
                  </Link>
                ))}
              </StyledSlider>
            )}
            <StyledShowAlldiv>
              {props.Loading == true ? (
                <div style={{ textAlign: "left" }}>
                  <SkeletonCM Width={150} mLeft={10} />
                </div>
              ) : (
                <Button>
                  <Link to={"/Furniture/amazing"}>
                    <FaChevronLeft /> مشاهده همه
                  </Link>
                </Button>
              )}
            </StyledShowAlldiv>
          </StyledMainTop>
          {/* ) : (
            ""
          )} */}
        </div>
        {props.Loading == true ? (
          <div style={{ width: "100% !important" }}>
            <Grid
              container
              pl={"40px"}
              pr={"40px"}
              style={{ direction: "rtl", background: "#cdcdcd" }}
            >
              <Grid item md={6} xs={12}>
                <div style={{ padding: "10px" }}>
                  <SkeletonCM Height={400} mBottom={10} />
                </div>
              </Grid>
              <Grid item md={6} xs={12}>
                <div style={{ padding: "10px" }}>
                  <SkeletonCM Height={60} mBottom={10} Width={300} mTop={30} />
                  <SkeletonCM Height={35} mBottom={10} Count={6} />
                </div>
              </Grid>
            </Grid>
          </div>
        ) : (
          <StyledDiv style={{ marginBottom: "30px" }}>
            <Container>
              <Grid container spacing={2}>
                <Grid item md={6} xs={12}>
                  <StyledImg src={logo} alt="slide" />
                </Grid>
                <StyledGridTop item md={6} xs={12}>
                  <Styledh2>تولیدی مبلمان ویول</Styledh2>
                  <StyledTypographyContent>
                    <Link to="/aboutus">{parse(props.aboutUs)}</Link>
                  </StyledTypographyContent>
                </StyledGridTop>
              </Grid>
            </Container>
          </StyledDiv>
        )}
        {/* {props.furnitureProducts.length > 4 ? ( */}
        <StyledMain id="furniture" style={{ paddingTop: "6px" }}>
          {props.Loading == true ? (
            <div style={{ textAlign: "center" }}>
              <SkeletonCM Width={300} />
            </div>
          ) : (
            <StyledTitle>مبلمان</StyledTitle>
          )}

          {props.Loading == true ? (
            <div>
              <StyledSlider {...settingsSkeleton}>
                {skeleton.map((product, index) => (
                  <SkeletonProductCM key={index} />
                ))}
              </StyledSlider>
            </div>
          ) : (
            <StyledSlider {...settings}>
              {props.furnitureProducts.map((product, index) => (
                <Link to={`/product/${product.id}`} key={"product" + index}>
                  <StyledSlideProductDiv>
                    <StyledImgdiv>
                      {product.image == null ? (
                        <img src={notfound} alt={product.title} />
                      ) : (
                        <img
                          src={IMG_BASE_URL + product.image}
                          alt={product.title}
                        />
                      )}
                    </StyledImgdiv>
                    <StyledColorsProduct>
                      {product.colors?.map((color, index) => (
                        <span
                          key={"color" + index}
                          style={{ background: color.color_code }}
                        ></span>
                      ))}
                    </StyledColorsProduct>
                    <h2>{product.title}</h2>
                    {product.discount_percent != 0 ? (
                      <p className="product-p">
                        <span> {spliter(product?.before_discount_price)} </span>
                        <span> تومان </span>
                      </p>
                    ) : (
                      <p style={{ height: "26px" }}></p>
                    )}
                    <p>
                      <span style={{ color: "#424242" }}>
                        {" "}
                        {spliter(product.price)}{" "}
                      </span>
                      <span style={{ color: "c3c3c3" }}> تومان </span>
                    </p>
                    {product.discount_percent != 0 ? (
                      <StyledSlideProductDiscount>
                        {" "}
                        {product.discount_percent} %{" "}
                      </StyledSlideProductDiscount>
                    ) : (
                      " "
                    )}
                  </StyledSlideProductDiv>
                </Link>
              ))}
            </StyledSlider>
          )}

          <StyledShowAlldiv>
            {props.Loading == true ? (
              <div style={{ textAlign: "left" }}>
                <SkeletonCM Width={150} mLeft={10} />
              </div>
            ) : (
              <Button>
                <Link to={"/Furniture"}>
                  <FaChevronLeft /> مشاهده همه
                </Link>
              </Button>
            )}
          </StyledShowAlldiv>
        </StyledMain>
        {/* ) : (
          ""
        )} */}
      </div>

      <div style={{ width: "100% !important" }}>
        <Grid container pl={"40px"} pr={"40px"} style={{ direction: "rtl" }}>
          <Grid item xs={12} sm={6}>
            {props.Loading == true ? (
              <div style={{ padding: "10px" }}>
                <SkeletonCM Height={300} mBottom={10} />
              </div>
            ) : (
              <Link to={"/Furniture"}>
                <img
                  src={baner2}
                  alt="banner"
                  style={{
                    borderRadius: "10px",
                    paddingBottom: "10px",
                    paddingTop: "10px",
                    paddingLeft: "10px",
                    paddingRight: "10px",
                  }}
                />
              </Link>
            )}
          </Grid>
          <Grid item xs={12} sm={6}>
            {props.Loading == true ? (
              <div style={{ padding: "10px" }}>
                <SkeletonCM Height={300} mBottom={10} />
              </div>
            ) : (
              <Link to={"/accessory"}>
                <img
                  src={baner1}
                  alt="banner"
                  style={{
                    borderRadius: "10px",
                    paddingBottom: "10px",
                    paddingTop: "10px",
                    paddingLeft: "10px",
                    paddingRight: "10px",
                  }}
                />
              </Link>
            )}
          </Grid>
        </Grid>
      </div>

      <div>
        <div style={{ marginTop: "46px" }}>
          {/* {props.amazingAccessoryProducts.length > 4 ? ( */}
          <StyledMainTop>
            {props.Loading == true ? (
              <div style={{ textAlign: "center" }}>
                <SkeletonCM Width={300} />
              </div>
            ) : (
              <StyledTitle>پیشنهاد شگفت انگیز اکسسوری</StyledTitle>
            )}

            {props.Loading == true ? (
              <div>
                <StyledSlider {...settingsSkeleton}>
                  {skeleton.map((product, index) => (
                    <SkeletonProductCM key={index} />
                  ))}
                </StyledSlider>
              </div>
            ) : (
              <StyledSlider {...settingsAmazing}>
                {props.amazingAccessoryProducts.map((product, index) => (
                  <Link to={`/product/${product.id}`} key={"product" + index}>
                    <StyledSlideProductDiv>
                      <StyledImgdiv>
                        {product.image == null ? (
                          <img src={notfound} alt={product.title} />
                        ) : (
                          <img
                            src={IMG_BASE_URL + product.image}
                            alt={product.title}
                          />
                        )}
                      </StyledImgdiv>
                      <StyledColorsProduct>
                        {product.colors?.map((color, index) => (
                          <span
                            key={"color" + index}
                            style={{ background: color.color_code }}
                          ></span>
                        ))}
                      </StyledColorsProduct>
                      <h2>{product.title}</h2>
                      {product.discount_percent !== 0 ? (
                        <p className="product-p">
                          <span>
                            {" "}
                            {spliter(product?.before_discount_price)}{" "}
                          </span>
                          <span> تومان </span>
                        </p>
                      ) : (
                        <p style={{ height: "26px" }}></p>
                      )}
                      <p>
                        <span style={{ color: "#424242" }}>
                          {" "}
                          {spliter(product.price)}{" "}
                        </span>
                        <span style={{ color: "c3c3c3" }}> تومان </span>
                      </p>
                      {product.discount_percent !== 0 ? (
                        <StyledSlideProductDiscount>
                          {" "}
                          {product.discount_percent} %{" "}
                        </StyledSlideProductDiscount>
                      ) : (
                        " "
                      )}
                    </StyledSlideProductDiv>
                  </Link>
                ))}
              </StyledSlider>
            )}

            <StyledShowAlldiv>
              {props.Loading == true ? (
                <div style={{ textAlign: "left" }}>
                  <SkeletonCM Width={150} mLeft={10} />
                </div>
              ) : (
                <Button>
                  <Link to={"/accessory/amazing"}>
                    <FaChevronLeft /> مشاهده همه
                  </Link>
                </Button>
              )}
            </StyledShowAlldiv>
          </StyledMainTop>
          {/* ) : (
            ""
          )} */}
        </div>
        <StyledDiv style={{ background: "transparent", padding: "0" }}>
          <Container style={{ maxWidth: "100%", padding: "0" }}>
            {props.Loading == true ? (
              <SkeletonCM Height={300} mBottom={10} />
            ) : (
              <StyledSliderAcc {...settingsGallary}>
                {props.slider.map((slide, index) => (
                  <div key={index}>
                    <img src={IMG_BASE_URL + slide.image} alt="banner" />
                  </div>
                ))}
              </StyledSliderAcc>
            )}
          </Container>
        </StyledDiv>
        {/* {props.AccessoryProducts.length > 4 ? ( */}
        <StyledMain id="accessory" style={{ paddingTop: "6px" }}>
          {props.Loading == true ? (
            <div style={{ textAlign: "center" }}>
              <SkeletonCM Width={300} />
            </div>
          ) : (
            <StyledTitle>اکسسوری</StyledTitle>
          )}

          {props.Loading == true ? (
            <div>
              <StyledSlider {...settingsSkeleton}>
                {skeleton.map((product, index) => (
                  <SkeletonProductCM key={index} />
                ))}
              </StyledSlider>
            </div>
          ) : (
            <StyledSlider {...settings}>
              {props.AccessoryProducts.map((product, index) => (
                <Link to={`/product/${product.id}`} key={"product" + index}>
                  <StyledSlideProductDiv>
                    <StyledImgdiv>
                      {product.image == null ? (
                        <img src={notfound} alt={product.title} />
                      ) : (
                        <img
                          src={IMG_BASE_URL + product.image}
                          alt={product.title}
                        />
                      )}
                    </StyledImgdiv>
                    <StyledColorsProduct>
                      {product.colors?.map((color, index) => (
                        <span
                          key={"color" + index}
                          style={{ background: color.color_code }}
                        ></span>
                      ))}
                    </StyledColorsProduct>
                    <h2>{product.title}</h2>
                    {product.discount_percent != 0 ? (
                      <p className="product-p">
                        <span> {spliter(product?.before_discount_price)} </span>
                        <span> تومان </span>
                      </p>
                    ) : (
                      <p style={{ height: "26px" }}></p>
                    )}
                    <p>
                      <span style={{ color: "#424242" }}>
                        {" "}
                        {spliter(product.price)}{" "}
                      </span>
                      <span style={{ color: "c3c3c3" }}> تومان </span>
                    </p>
                    {product.discount_percent != 0 ? (
                      <StyledSlideProductDiscount>
                        {" "}
                        {product.discount_percent} %{" "}
                      </StyledSlideProductDiscount>
                    ) : (
                      " "
                    )}
                  </StyledSlideProductDiv>
                </Link>
              ))}
            </StyledSlider>
          )}

          <StyledShowAlldiv>
            {props.Loading == true ? (
              <div style={{ textAlign: "left" }}>
                <SkeletonCM Width={150} mLeft={10} />
              </div>
            ) : (
              <Button>
                <Link to={"/accessory"}>
                  <FaChevronLeft /> مشاهده همه
                </Link>
              </Button>
            )}
          </StyledShowAlldiv>
        </StyledMain>
        {/* ) : (
          ""
        )} */}
      </div>
    </>,
    document.getElementById("main_home")
  );
}

export default MainHomeCM;
